async function a(c, o) {
  const s = [], e = [];
  for (const [n, r] of c.entries()) {
    const i = r().then((t) => {
      s[n] = { status: "fulfilled", value: t };
    }).catch((t) => {
      s[n] = { status: "rejected", reason: t };
    }).then(() => {
      const t = e.indexOf(i);
      t !== -1 && e.splice(t, 1);
    });
    e.push(i), e.length >= o && await Promise.race(e);
  }
  return await Promise.all(e), s;
}
export {
  a as executeWithConcurrencyLimit
};
